import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WallboardModule } from '../../wallboards/wallboards.model';
import { CVLocalizationService } from '../services/cv-localization.service';
import SlideoutSettingsManager from '../../../shared/models/slideout-settings-manager';

@Component({
  selector: 'cv-general-wallboard-settings-selector',
  templateUrl: './general-wallboard-settings-selector.component.html',
  styleUrl: './general-wallboard-settings-selector.component.scss'
})
export class GeneralWallboardSettingsSelectorComponent {
    @Input() settingsToUse: WallboardModule;
    @Input() settingsManager: SlideoutSettingsManager;
    @Output() selectedGeneralSettingsChanged = new EventEmitter<any>();

    generalSettingsDisplayText: string = "";
    paginationDisclaimerText: string = "";
    minValue;
    secValue;

    constructor(
        private localizationService: CVLocalizationService,
    ) { }

    async ngOnInit() {
        await this.localizationService.GetSection('Wallboard_Slideout');

        this.paginationDisclaimerText = this.localizationService.getCachedText('Wallboard_Slideout', 'Summary_Disclaimer',
        `If a substantial number of participants are included in the summary,the slide duration you choose may be overridden by the minimum display time per page(3 seconds) necessary to show all participants.`);

        if (this.settingsManager.generalWallboardSettings?.SlideDuration)
            this.setMinAndSecValues();
        if (this.settingsManager.generalWallboardSettings)
            this.setGeneralSettingsDisplay();
    }

    ngOnChanges() {
    }

    cleanKeyPress(event: any) {
        const inputChar = String.fromCharCode(event.charCode);
        let cleanedChar = '';
        let currentValue = event.target.value;

        cleanedChar = inputChar.replace(/[^0-9]/g, '');
        if (cleanedChar !== '') {
            currentValue += cleanedChar;
        }
        else {
            //prevent input of invalid character
            event.preventDefault();
        }
    }

    setMinAndSecValues() {
        this.minValue = (Math.floor(this.settingsManager.generalWallboardSettings.SlideDuration / 60)).toString();
        this.secValue = (this.settingsManager.generalWallboardSettings.SlideDuration % 60).toString();
    }

    calculateSlideDuration() {
        const min = this.minValue ? parseInt(this.minValue) : 0;
        const sec = this.secValue ? parseInt(this.secValue) : 0;
        this.settingsManager.generalWallboardSettings.SlideDuration = (min * 60) + sec;
    }

    setGeneralSettingsDisplay() {
        const slideDuration = this.localizationService.getCachedText('Wallboard_Slideout', 'Slide_Duration', 'Slide Duration');
        const min = this.localizationService.getCachedText('Wallboard_Slideout', 'Min', 'Min');
        const sec = this.localizationService.getCachedText('Wallboard_Slideout', 'Sec', 'Sec');
        const showBackdrop = this.localizationService.getCachedText('Wallboard_Slideout', 'Show_Backdrop_Simple', 'Show Backdrop');
        const showTitle = this.localizationService.getCachedText('Wallboard_Slideout', 'Show_Title_Simple', 'Show Title');
        const paginationSet = this.localizationService.getCachedText('Wallboard_Slideout', 'Pagination_Set', 'Pagination Set');
        const showTotals = this.localizationService.getCachedText('Wallboard_Slideout', 'Show_Totals_Simple', 'Show Totals');
        const showRanking = this.localizationService.getCachedText('Wallboard_Slideout', 'Show_Ranking', 'Show Ranking');

        let displayText = '';

        if (!this.settingsManager.generalWallboardSettings.SlideDuration)
            this.calculateSlideDuration();

        Object.keys(this.settingsManager.generalWallboardSettings).forEach(setting => {
            if (!(setting in this.settingsManager.generalWallboardSettings))
                return;
            switch (setting) {
                case 'SlideDuration': {
                    displayText += `${slideDuration}`;
                    if (this.minValue && this.minValue != 0)
                        displayText += ` ${this.minValue} ${min}`;
                    if (this.secValue && this.secValue != '')
                        displayText += ` ${this.secValue} ${sec}`;
                    break;
                }
                case 'UseBackdrop': {
                    if (this.settingsManager.generalWallboardSettings.UseBackdrop)
                        displayText += `, ${showBackdrop}`;
                    break;
                }
                case 'ShowTitle': {
                    if (this.settingsManager.generalWallboardSettings.ShowTitle)
                        displayText += `, ${showTitle}`;
                    break;
                }
                case 'UsePagination': {
                    if(this.settingsManager.generalWallboardSettings.UsePagination)
                        displayText += `, ${paginationSet}`;
                    break;
                }
                case 'UseTotalsRow': {
                    if(this.settingsManager.generalWallboardSettings.UseTotalsRow)
                        displayText += `, ${showTotals}`;
                    break;
                }
                case 'ShowRanking': {
                    if(this.settingsManager.generalWallboardSettings.ShowRanking)
                        displayText += `, ${showRanking}`;
                    break;
                }
                default:
                    break;
            }
        });  
        this.settingsManager.generalWallboardSettings.generalDetailText = displayText;
        this.onGeneralDetailChange();
    }

    onGeneralDetailChange() {
        this.calculateSlideDuration();
        this.selectedGeneralSettingsChanged.emit();
    }
}
